/**
 * Contrat d'un tour guidé (driver.js).
 *
 * @remarks
 * Un tour = un identifiant stable + une liste d'étapes + une préparation
 * optionnelle de la mise en page. Les ancres sont des attributs
 * `[data-tour="…"]` posés dans les composants ciblés ; le contrôleur
 * (`use-guided-tour`) est agnostique du tour qu'il pilote.
 */

export const TOUR_IDS = {
  /** Outils de la page d'évaluation (SAAS-740, SAAS-952). */
  EVALUATION: 'evaluation',
  /** Sections principales de l'application — rail + header (SAAS-1145). */
  APP_OVERVIEW: 'app-overview',
} as const;

export type TourId = (typeof TOUR_IDS)[keyof typeof TOUR_IDS];

export interface GuidedTourStep {
  /** Sélecteur CSS brut de l'élément à surligner. */
  selector: string;
  title: string;
  description: string;
  /**
   * Onglet à activer avant d'afficher l'étape : une vue de panneau n'est montée
   * que sur son onglet actif, donc son ancre n'existe pas avant ce basculement.
   */
  activeTab?: { side: 'left' | 'right'; id: string };
  /**
   * Étape sautée si son ancre n'apparaît jamais (`skipMissingElement` de
   * driver.js). Pour les ancres conditionnelles : formulaire non rendu,
   * feature derrière un flag, bouton masqué sur certains contextes.
   */
  optional?: boolean;
}

export interface TourDefinition {
  id: TourId;
  steps: readonly GuidedTourStep[];
  /**
   * Mise en page à appliquer avant le lancement (ouvrir un panneau, activer un
   * onglet…) pour garantir que les ancres de la première étape existent.
   */
  prepare?: () => void;
}
